import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, image, url }) => {
  const defaultTitle = 'Ramspheld.Dev | AI & Sustainable Tech';
  const defaultDescription = 'Engineering Ethical AI & Sustainable Tech for Africa';
  const defaultKeywords = 'AI, sustainable tech, Africa, machine learning, ethical AI, innovation';
  const defaultImage = '/assets/og-image.png';
  const defaultUrl = 'https://ramspheld.dev';

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    keywords: keywords || (Array.isArray(keywords) ? keywords.join(', ') : defaultKeywords),
    image: image || defaultImage,
    url: url || defaultUrl,
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Ramspheld',
    url: seo.url,
    jobTitle: 'AI & Systems Engineer',
    worksFor: {
      '@type': 'Organization',
      name: 'Ramspheld.Dev',
      url: seo.url
    },
    description: seo.description,
    sameAs: [
      'https://github.com/ramspheld',
      'https://linkedin.com/in/ramspheld',
      'https://twitter.com/ramspheld'
    ],
    image: seo.image,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Nairobi',
      addressCountry: 'KE'
    }
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#0ea5e9" />
      <link rel="canonical" href={seo.url} />
      <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
      <link rel="apple-touch-icon" href="/logo192.svg" />
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default SEO;
